"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReleaseNotesController;
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _react = _interopRequireWildcard(require("react"));
var _Gift = _interopRequireDefault(require("../icons/Gift"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ReleaseNotesController({
  user,
  organization,
  iconProps,
  buttonStyle
}) {
  const handleClick = organization => {
    window.OlvyUtils.showWidget(organization, 'app_release_widget');
  };
  (0, _react.useEffect)(() => {
    if (process.env.NODE_ENV !== 'production') return;
    const script = document.createElement('script');
    script.async = true;
    script.id = 'olvy';
    if (organization === 'tadanow') {
      const olvyConfig = document.createElement('script');
      olvyConfig.type = 'text/javascript';
      olvyConfig.innerHTML = `var OlvyConfig = { workspaceAlias: "${organization}"}`;
      document.body.appendChild(olvyConfig);
      script.src = `https://app.olvy.co/scriptV2.js`;
      script.onload = function () {
        window.OlvyUtils.setUser(organization, {
          name: user.firstName,
          email: user.email,
          identifier: user.userId
        });
        window.Olvy(organization);
        return function cleanup() {
          window.Olvy.teardown();
        };
      };
    }
    if (organization === 'tadawebsuite') {
      script.src = `https://app.olvy.co/script.js`;
      script.onload = function () {
        window.Olvy.setUser({
          name: user.firstName,
          email: user.email,
          identifier: user.userId
        });
        window.Olvy.init({
          organisation: organization,
          target: '#olvy-target',
          type: 'modal',
          view: {
            showSearch: true,
            compact: false,
            showHeader: true,
            showUnreadIndicator: true,
            unreadIndicatorColor: '#cc1919',
            unreadIndicatorPosition: 'top-right'
          }
        });
        return function cleanup() {
          window.Olvy.teardown();
        };
      };
    }
    document.body.appendChild(script);
  }, []);
  if (process.env.NODE_ENV !== 'production') return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: organization === 'tadanow' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      sx: buttonStyle,
      id: "olvy-whats-new",
      onClick: () => handleClick(organization),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: "Release notes",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Gift.default, {
          ...iconProps
        })
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      sx: buttonStyle,
      id: "olvy-target",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
        title: "Release notes",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Gift.default, {
          ...iconProps
        })
      })
    })
  });
}